import { Icon } from '@aqarmap/aqarmap-ui';

export default function ErrorBanner({
  children,
  onClose,
}: {
  children: React.ReactNode;
  onClose: () => void;
}) {
  return (
    <div className="bg-[#FFF1F1] flex w-full rounded-[8px] border-s-[4px] border-[#E50C0C] items-start gap-1.5x px-2x py-1.5x">
      <button
        type="button"
        aria-label="close-error"
        onClick={onClose}
        className="element-center h-2.5x w-2.5x shrink-0 rounded-full bg-red_dark text-white"
      >
        <Icon name="close" size="20px" />
      </button>
      <div className="flex flex-col gap-[2px] text-link text-black">
        {children}
      </div>
    </div>
  );
}
